var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZfLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ZF_Logo_Blue",
    "data-name": "ZF Logo Blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M173.8,157.8a16,16,0,1,0-16,16,16,16,0,0,0,16-16m-28.669-6.967h7.791L146.5,166.72h22.662a14.449,14.449,0,0,1-24.028-15.887m21.928,6.91V155.79h-3.918v-4.946h7.306a14.495,14.495,0,0,1,0,13.934h-18.5l6.414-15.887H146.43a14.468,14.468,0,0,1,22.741,0H158.839v14.453h4.313v-5.6Z",
    transform: "translate(-141.8 -141.8)",
    fill: "#0057b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZfLogoBlue);
export default __webpack_public_path__ + "static/media/ZF_Logo_Blue.46f8f0257bdb76605b2564237fd08762.svg";
export { ForwardRef as ReactComponent };